<template>
<div class="chapter">
<div class="inner_page">
      ﻿


<title>Ball Park</title>
<link href="../styles/styles.css" rel="stylesheet" type="text/css"/>
<link href="../styles/additional.css" rel="stylesheet" type="text/css"/>
<h2 class="part-number1">PART ONE</h2>
<h2 class="part-title1">1975</h2>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part001.vue?707a8f5a